module.exports = __webpack_public_path__ + "assets/img/swf.013e415a.svg";